module.exports = __webpack_public_path__ + "img/logo-section.4346472a.svg";